/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { CultureID } from '../Localization/CultureID';
import { ReelEvent } from '../Reel/ReelEvent';
import { StateID } from '../StateManager/StateID';
import { ReferenceGroup } from './Component/ComponentReference/ReferenceGroup';
import { LogTypes } from './ComponentLogger';
import { RequestType } from './RequestType';
import { ccTouchEvent } from './TouchEvent';

const {ccclass, property} = cc._decorator;

// tslint:disable:class-name
// tslint:disable:typedef
export class ccEnum
{
    public static readonly RequestType =  cc.Enum(RequestType);
    public static readonly ccKEY = cc.Enum(cc.KEY);
    public static readonly LogTypes = cc.Enum(LogTypes);
    public static readonly CultureID = cc.Enum(CultureID);
    public static readonly ReferenceGroup = cc.Enum(ReferenceGroup);
    public static readonly StateID = cc.Enum(StateID);
    public static readonly TouchEvent = cc.Enum(ccTouchEvent);
    public static readonly ReelEvent = cc.Enum(ReelEvent);
}
